import React from 'react';
import { LeftNavSection } from '../../../privacy/components/LeftNavSection/LeftNavSection';
import mostViewedNavOpts from '../../../privacy/jsonData/leftNavOptions/MostViewed.json';
import shippingAndDeliveryOpts from '../../../privacy/jsonData/leftNavOptions/ShippingAndDeliveryOpts.json';
import productAndServicesOpts from '../../../privacy/jsonData/leftNavOptions/ProductAndServices.json';
import pricingAndPromosOpts from '../../../privacy/jsonData/leftNavOptions/PricingAndPromos.json';
import paymentsOpts from '../../../privacy/jsonData/leftNavOptions/paymentsOpts.json';
import myAccount from '../../../privacy/jsonData/leftNavOptions/MyAccountOpts.json';
import returnsAndRecallsOpts from '../../../privacy/jsonData/leftNavOptions/ReturnsAndRecallsOpts.json';
import policiesAndLegalOpts from '../../../privacy/jsonData/leftNavOptions/PoliciesAndLegalOpts.json';
import corporateInformationOpts from '../../../privacy/jsonData/leftNavOptions/CorporateInformationOpts.json';
import contactUsOpts from '../../../privacy/jsonData/leftNavOptions/ContactUsOpts.json';

export function LeftNav() {
  return (
    <div className="sui-pr-4">
      <LeftNavSection opts={mostViewedNavOpts} />
      <LeftNavSection opts={shippingAndDeliveryOpts} />
      <LeftNavSection opts={productAndServicesOpts} />
      <LeftNavSection opts={pricingAndPromosOpts} />
      <LeftNavSection opts={paymentsOpts} />
      <LeftNavSection opts={myAccount} />
      <LeftNavSection opts={returnsAndRecallsOpts} />
      <LeftNavSection opts={policiesAndLegalOpts} />
      <LeftNavSection opts={corporateInformationOpts} />
      <LeftNavSection opts={contactUsOpts} />
    </div>
  );
}
